// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signin-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

.signin-form {
  background: white;
  padding: 32px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  width: 320px;
}

.signin-form h2 {
  margin-bottom: 24px;
  text-align: center;
  color: #333;
}

.signin-form input {
  margin-bottom: 16px;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 16px;
}

.signin-form button {
  background: #007bff;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  font-weight: bold;
  margin-bottom: 8px;
}

.signin-form button:hover {
  background: #0056b3;
}

.error {
  color: #d32f2f;
  background: #ffebee;
  padding: 8px;
  border-radius: 4px;
  text-align: center;
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SignIn.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".signin-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f5f5f5;\n}\n\n.signin-form {\n  background: white;\n  padding: 32px 24px;\n  border-radius: 8px;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.08);\n  display: flex;\n  flex-direction: column;\n  width: 320px;\n}\n\n.signin-form h2 {\n  margin-bottom: 24px;\n  text-align: center;\n  color: #333;\n}\n\n.signin-form input {\n  margin-bottom: 16px;\n  padding: 10px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  font-size: 16px;\n}\n\n.signin-form button {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 12px;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  font-weight: bold;\n  margin-bottom: 8px;\n}\n\n.signin-form button:hover {\n  background: #0056b3;\n}\n\n.error {\n  color: #d32f2f;\n  background: #ffebee;\n  padding: 8px;\n  border-radius: 4px;\n  text-align: center;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
